// src/config.js - Production-ready environment configuration
// Centralized config for API URLs and environment detection
import logger from './services/logger';

// Detect environment
const isDevelopment = process.env.NODE_ENV === 'development';
const isProduction = process.env.NODE_ENV === 'production';

// API Base URL - Auto-detects environment
// In development: Uses localhost
// In production: Uses environment variable (set in Vercel)
export const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? '/api'
  : (process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:3000');

// Supabase configuration (already using env vars)
export const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
export const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Helper function to build API URLs
export const getApiUrl = (endpoint) => {
  // Ensure endpoint starts with /
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${API_BASE_URL}${cleanEndpoint}`;
};

// Helper function to build full API URLs (with /api prefix)
export const getFullApiUrl = (endpoint) => {
  // Remove /api if user already included it
  const cleanEndpoint = endpoint.replace(/^\/api/, '');
  return getApiUrl(`/api${cleanEndpoint}`);
};

// Environment info
export const config = {
  isDevelopment,
  isProduction,
  apiBaseUrl: API_BASE_URL,
  supabaseUrl: SUPABASE_URL,
  supabaseAnonKey: SUPABASE_ANON_KEY,
};

// Debug helper (only logs in development)
if (isDevelopment) {
  logger.debug('App Configuration:', {
    environment: process.env.NODE_ENV,
    apiBaseUrl: API_BASE_URL,
    supabaseConfigured: !!(SUPABASE_URL && SUPABASE_ANON_KEY),
  });
}

export default config;
